/** @flow */

import {
  GetEmployeeIdentityData,
  GetEmployeeIdentityDataSuccess,
  GetEmployeeIdentityDataError,
  UpdatePlatformDataSecurityEmployeeIdentity,
  UpdatePlatformDataSecurityEmployeeIdentitySuccess,
  UpdatePlatformDataSecurityEmployeeIdentityError,
  GetPlatformDataSecurityEmployeeIdentitySchema,
  GetPlatformDataSecurityEmployeeIdentitySchemaSuccess,
  GetPlatformDataSecurityEmployeeIdentitySchemaError,
} from "@modules/service/constants/actions";
import * as employeeIdentityReducers from "./reducers";
import initialState from "./state";
import type { EmployeeIdentityState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: EmployeeIdentityState = initialState,
  action: Object,
): EmployeeIdentityState => {
  const act = {
    [GetEmployeeIdentityData]: employeeIdentityReducers.onGetEmployeeIdentityData,
    [GetEmployeeIdentityDataSuccess]: employeeIdentityReducers.onGetEmployeeIdentityDataSuccess,
    [GetEmployeeIdentityDataError]: employeeIdentityReducers.onGetEmployeeIdentityDataError,
    [UpdatePlatformDataSecurityEmployeeIdentity]:
      employeeIdentityReducers.onUpdatePlatformDataSecurityEmployeeIdentity,
    [UpdatePlatformDataSecurityEmployeeIdentitySuccess]:
      employeeIdentityReducers.onUpdatePlatformDataSecurityEmployeeIdentitySuccess,
    [UpdatePlatformDataSecurityEmployeeIdentityError]:
      employeeIdentityReducers.onUpdatePlatformDataSecurityEmployeeIdentityError,
    [GetPlatformDataSecurityEmployeeIdentitySchema]:
      employeeIdentityReducers.onGetPlatformDataSecurityEmployeeIdentitySchema,
    [GetPlatformDataSecurityEmployeeIdentitySchemaSuccess]:
      employeeIdentityReducers.onGetPlatformDataSecurityEmployeeIdentitySchemaSuccess,
    [GetPlatformDataSecurityEmployeeIdentitySchemaError]:
      employeeIdentityReducers.onGetPlatformDataSecurityEmployeeIdentitySchemaError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
